var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBarcode(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 138.644,
    height: 59.094,
    viewBox: "0 0 138.644 59.094",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "barcode-of-square-shape-svgrepo-com",
    transform: "translate(0 -1.001)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1",
    "data-name": "Path 1",
    d: "M15.1,1h1.466V60.1H15.1ZM0,60.1H6.82V1H0Zm45.8,0h1.706V1H45.8Zm4.634,0h6.82V1h-6.82Zm-19.007,0h6.82V1H31.43Zm-9.748,0h1.462V1H21.682Zm4.634,0h1.457V1H26.316Zm50.432,0h6.825V1H76.748Zm19.731,0h1.466V1H96.479Zm-4.625,0h1.466V1H91.854Zm-29.474,0h1.457V1H62.38ZM67,60.1h6.825V1H67Zm55.081,0H128.9V1h-6.815ZM131.824,1V60.1h6.82V1ZM112.817,60.1h1.7V1h-1.7Zm-9.743,0h1.466V1h-1.466Zm4.625,0h1.462V1H107.7Z",
    transform: "translate(0 0)",
    fill: "#425175"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBarcode);
export default __webpack_public_path__ + "static/media/barcode.f88d1bc7b0651e0156887a06895caf09.svg";
export { ForwardRef as ReactComponent };